import axios from 'axios'
import errorHandler from './error-handler'
import qs from 'querystring'

export default {
  async list () {
    return axios.get('/api/hirers').then(r => r.data)
  },
  async register (data) {
    return axios.post('/api/hirers', data).then(r => r.data)
  },
  async update (data) {
    return axios.put('/api/hirers/', data).then(r => r.data)
  },
  async get (id) {
    return axios.get(`/api/hirers/${id}`).then(r => r.data)
  },
  async attach (data) {
    return axios.post('/api/hirers/attach', data).then(r => r.data)
  },
  async getHirerJobBoards (value) {
    return axios.get(`/api/job_board/list?${qs.stringify(value)}`).then(r => r.data)
  },
  async getHirerJobBoardsList () {
    return axios.get(`/api/job_board/list`).then(r => r.data)
  },
  async getJobBoardOwnerHirers (id) {
    return axios.get(`/api/job_board/${id}/get-hirers`).then(r => r.data).catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/hirers.js